import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompaniesService } from 'src/app/core/companies.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';

@Component({
  selector: 'app-companies-archived-note-dialog',
  templateUrl: './companies-archived-note-dialog.component.html',
  styleUrls: ['./companies-archived-note-dialog.component.scss'],
})
export class CompaniesArchivedNoteDialogComponent {
  is_archive_note_running: boolean = false;
  company_id?: string;
  note?: string;

  company_archive_note_form_group: FormGroup;
  error_matcher: FormErrorStateMatcher;

  constructor(
    private dialog_ref: MatDialogRef<CompaniesArchivedNoteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private error_service: ErrorService,
    private companies_service: CompaniesService,
    private form_service: FormService,
  ) {
    this.company_id = data.company_id;
    this.company_archive_note_form_group = this.form_service.company_archive_note_form_group;
    this.note = data.note;
    this.error_matcher = this.form_service.matcher;
  }

  ngOnInit(): void {
    this.company_archive_note_form_group.get(this.form_service.note_label)?.setValue(this.note);
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onArchiveNoteClick(): void {
    if (this.company_id) {
      const note = this.company_archive_note_form_group.get(this.form_service.note_label)?.value;
      this.archiveNote(this.company_id, note);
    }
  }

  archiveNote(company_id: string, note: string): void {
    this.is_archive_note_running = true;
    this.companies_service.setArchivedNote(company_id, note).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_archive_note_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_archive_note_running = false;
      },
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.company_archive_note_form_group);
  }
}
